import { z } from 'zod'

export const SERVER_DATE_TIME_FORMAT = 'yyyy-MM-ddTHH:mm:ssZ'
export const SERVER_DATE_FORMAT = 'yyyy-MM-dd'
export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy'
export const DEFAULT_DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm'
export const DEFAULT_TIME_FORMAT = 'HH:mm'

export enum Language {
  De = 'de',
  En = 'en',
}

export enum MarketKey {
  De = 'de',
  At = 'at',

  /**
   * @deprecated Use a different market key.
   */
  Gb = 'gb',
  /**
   * @deprecated Use a different market key.
   */
  Fr = 'fr',
}

export enum SupportedMarketKey {
  De = 'de',
  At = 'at',
}

export const LANGUAGES_PER_MARKET = {
  de: [Language.De, Language.En],
  at: [Language.De, Language.En],
} as const

export type LanguagesPerMarket = typeof LANGUAGES_PER_MARKET

const getAllowedLanguageAndMarketCombinations = <
  TMarket extends SupportedMarketKey,
  TLanguages extends Language = LanguagesPerMarket[TMarket][number],
>(
  market: TMarket
): `${TLanguages}-${TMarket}`[] => {
  return (LANGUAGES_PER_MARKET[market] as unknown as TLanguages[]).map(
    (language): `${TLanguages}-${TMarket}` => `${language}-${market}`
  )
}

export const ALLOWED_LANGUAGE_LANG_MARKET_COMBINATIONS = [
  ...getAllowedLanguageAndMarketCombinations(SupportedMarketKey.De),
  ...getAllowedLanguageAndMarketCombinations(SupportedMarketKey.At),
]

export enum Currency {
  Eur = 'EUR',
}

export const currencyKey: Record<SupportedMarketKey, Currency> = {
  [SupportedMarketKey.De]: Currency.Eur,
  [SupportedMarketKey.At]: Currency.Eur,
}

/**
 * @deprecated This is a deprecated market schema which will be removed when we can delete the Gb from the MarketKey enum.
 */
export const marketSchema = z.nativeEnum(MarketKey)

export const supportedMarketSchema = z.nativeEnum(SupportedMarketKey)

export const languageSchema = z.nativeEnum(Language)

export const getLocaleParts = (locale = ''): [Language, SupportedMarketKey] => {
  const [unparsedLang, unparsedMarket] =
    locale === 'default' ? [Language.En, SupportedMarketKey.De] : locale.split('-')
  return [languageSchema.parse(unparsedLang), supportedMarketSchema.parse(unparsedMarket)]
}
